import * as React from "react";
import { View, StyleSheet, Image, Text, TouchableOpacity } from "react-native";

function NavBar() {
  return (
    <View style={styles.navbar}>
      <View style={styles.container}>
        <Image
          source={{ uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/ca93bb6036b17a1a70f7c67d86a961b017f34c0e?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc" }}
          style={styles.logo}
        />
        <View style={styles.column}>
          <View style={styles.navColumn}>
            <View style={styles.navLinkDropdown}>
              <View style={styles.aboutUs}>
                <Text style={styles.navText}>About us</Text>
              </View>
              <Image
                source={{ uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/04c0f2f9e9f80c09a3302e7fd904c53cc77d73ad?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc" }}
                style={styles.dropdownIcon}
              />
            </View>
          </View>
          <View style={styles.buttonColumn}>
            <TouchableOpacity style={styles.authenticityButton}>
              <Text style={styles.authenticityButtonText}>Authenticity Check</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.contactButton}>
              <Text style={styles.contactButtonText}>Contact with us</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  navbar: {
    position: "absolute",
    zIndex: 1,
    display: "flex",
    minHeight: 36,
    width: 720,
    paddingLeft: 32,
    paddingRight: 32,
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    top: 0,
    height: 36,
  },
  container: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    gap: 100,
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  logo: {
    aspectRatio: 1.38,
    width: 33,
    alignSelf: "stretch",
    marginTop: "auto",
    marginBottom: "auto",
  },
  column: {
    alignSelf: "stretch",
    display: "flex",
    minWidth: 240,
    marginTop: "auto",
    marginBottom: "auto",
    alignItems: "center",
    gap: 16,
    justifyContent: "center",
    flexDirection: "row",
  },
  navColumn: {
    alignSelf: "stretch",
    display: "flex",
    marginTop: "auto",
    marginBottom: "auto",
    gap: 16,
    overflow: "hidden",
  },
  navLinkDropdown: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    justifyContent: "center",
    flexDirection: "row",
  },
  aboutUs: {
    alignSelf: "stretch",
    marginTop: "auto",
    marginBottom: "auto",
  },
  navText: {
    color: "rgba(236, 236, 236, 1)",
    fontSize: 8,
    fontWeight: "400",
  },
  dropdownIcon: {
    aspectRatio: 1,
    width: 12,
    alignSelf: "stretch",
    marginTop: "auto",
    marginBottom: "auto",
  },
  buttonColumn: {
    alignSelf: "stretch",
    display: "flex",
    marginTop: "auto",
    marginBottom: "auto",
    alignItems: "center",
    gap: 8,
    justifyContent: "center",
    flexDirection: "row",
  },
  authenticityButton: {
    alignSelf: "stretch",
    borderRadius: 25,
    borderColor: "rgba(236, 236, 236, 1)",
    borderStyle: "solid",
    borderWidth: 1,
    marginTop: "auto",
    marginBottom: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 4,
    paddingBottom: 4,
  },
  authenticityButtonText: {
    color: "rgba(236, 236, 236, 1)",
    fontSize: 8,
    fontWeight: "400",
  },
  contactButton: {
    alignSelf: "stretch",
    borderRadius: 25,
    borderColor: "rgba(236, 236, 236, 1)",
    borderStyle: "solid",
    borderWidth: 1,
    marginTop: "auto",
    marginBottom: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 4,
    paddingBottom: 4,
    backgroundColor: "rgba(236, 236, 236, 1)",
  },
  contactButtonText: {
    color: "rgba(11, 8, 28, 1)",
    fontSize: 8,
    fontWeight: "400",
  },
});

export default NavBar;
